import React from "react";
import {Container, Row, Col, Card} from "react-bootstrap";
import maintenanceImg from "../assets/images/maintenance.png";

const Maintenance = () => {
    return (
        <Container
            fluid
            className="d-flex justify-content-center align-items-center bg-light"
            style={{minHeight: "100vh"}}
        >
            <Row>
                <Col>
                    <Card
                        className="p-4 shadow-lg text-center"
                        style={{borderRadius: 20, maxWidth: 450, margin: "0 auto"}}
                    >
                        <div className="text-center">
                            <img src={maintenanceImg} alt="Maintenance" style={{width: 120, marginBottom: 20}}/>
                        </div>

                        <h2 className="fw-bold mb-3">
                            The site is currently down for maintenance
                        </h2>

                        <p className="text-muted mb-4">
                            We apologize for any inconveniences caused.
                            <br/>We've almost done.
                        </p>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Maintenance;
